import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { MdAssignmentLate } from "react-icons/md";
import {
  Header,
  ModuleContainer,
  IconContainer,
  IconStyle,
  TaskContainer,
  Icon,
  StatusSpace,
  TaskName,
  TaskStatus,
  ExtentionContainer,
  RefreshDeleteContainer,
} from "./styles";
import { CircularProgress } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import {
  CustomRemoveIcon,
  CustomRefreshIcon,
  CustomAddIcon,
} from "../../styles";
import { fetchDashboardTasks } from "../../../../../state/dashboard/actions";

const LoadingIndicator = () => (
  <div
    style={{ display: "flex", justifyContent: "center", alignItems: "center" }}
  >
    <CircularProgress />
  </div>
);

const TarefasAtrasadas = ({
  isExpanded,
  toggleExpand,
  isEditing,
  remove,
  restore,
  isExcluded,
}) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [lateTasks, setLateTasks] = useState([]);
  const dashTasks = useSelector((state) => state.dashboard.tasksProductivity);

  const handleTaskClick = (taskId) => {
    history.push(`/tasks?taskId=${taskId}&status=late`);
  };

  const renderControls = () => (
    <RefreshDeleteContainer>
      {isEditing ? (
        !isExcluded ? (
          <CustomRemoveIcon
            onClick={(e) => {
              e.stopPropagation();
              remove();
            }}
          />
        ) : (
          <CustomAddIcon
            onClick={(e) => {
              e.stopPropagation();
              restore();
            }}
          />
        )
      ) : (
        <CustomRefreshIcon
          onClick={(e) => {
            e.stopPropagation();
            dispatch(fetchDashboardTasks());
          }}
        />
      )}
    </RefreshDeleteContainer>
  );

  useEffect(() => {
    if (
      dashTasks.status === "succeeded" &&
      Array.isArray(dashTasks.data?.late)
    ) {
      const sortedLateTasks = [...dashTasks.data.late].sort((a, b) => {
        return (a.moment?.diffHours || 0) - (b.moment?.diffHours || 0);
      });

      setLateTasks(sortedLateTasks);
    }
  }, [dashTasks]);

  if (dashTasks.status !== "succeeded") {
    return (
      <ModuleContainer>
        <Header>
          <IconContainer>
            <MdAssignmentLate style={IconStyle} />
          </IconContainer>
          <LoadingIndicator />
        </Header>
      </ModuleContainer>
    );
  }
  if (dashTasks.status === "succeeded" && lateTasks.length === 0) {
    return (
      <ModuleContainer isEditing={isEditing}>
        <Header>
          <IconContainer>
            <MdAssignmentLate style={IconStyle} />
          </IconContainer>
          Tarefas Atrasadas: 0{renderControls()}
        </Header>
      </ModuleContainer>
    );
  }

  return (
    <ModuleContainer isEditing={isEditing}>
      <Header onClick={toggleExpand}>
        <IconContainer>
          <MdAssignmentLate style={IconStyle} />
        </IconContainer>
        Tarefas Atrasadas: {lateTasks.length}
        {renderControls()}
      </Header>
      {isExpanded && (
        <ExtentionContainer>
          {lateTasks.map((item, index) => (
            <TaskContainer
              onClick={() => handleTaskClick(item._id)}
              key={"task" + index}
            >
              <Icon>
                {item.data.accountable ? (
                  <img
                    alt=""
                    title={item.data.accountable.username}
                    src={item.data.accountable.avatarURL}
                  />
                ) : null}
              </Icon>
              <TaskName>{item.data.label}</TaskName>
              <StatusSpace>
                <TaskStatus>
                  Atrasada em ~{" "}
                  {item.moment.diffDays <= -1
                    ? -item.moment.diffDays.toFixed(1) + " dias"
                    : -item.moment.diffHours.toFixed(0) + " hora(s)"}
                </TaskStatus>
              </StatusSpace>
            </TaskContainer>
          ))}
        </ExtentionContainer>
      )}
    </ModuleContainer>
  );
};

export default TarefasAtrasadas;
